module.exports = __webpack_public_path__ + "static/img/background.a01b0bbd.png";